import React from "react"
import styled from "styled-components"
import SectionLayout from "../../Layouts/SectionLayout"
import Title from "../../components/Text/Title"
import Button from "../../components/SanityButton"
import Subtitle from "../../components/Text/Subtitle"
import { media, Responsive } from "../../components/mediaStyles"
import { colors, getColor } from "../../components/Color"
import SanityImage from "../../components/SanityImage"

const Block = styled.div`
  position: absolute;
  left: -65%;

  height: 80%;
  width: 150%;
  background: ${colors.teal};
  transform: skew(-18deg);
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;

  ${media.small`
    top: 20px;
    right: -55%;
    width: 100%;
    left: inherit;
    transform: skew(18deg);
  `}
`

const Filter = styled.div`
  height: 100%;
  width: 100%;
  background: ${getColor("secondary", 0.8)};
  position: absolute;
  z-index: 2000;
  top: 0;
  left: 0;
`

const Layout = styled(SectionLayout)`
  min-height: 75vh;
  // max-height: 650px;
  display: flex;
  flex-direction: column;

  ${media.small`
    justify-content: center;
    height: 850px;
    max-height: 850px;
  `}
`

const Headline = styled.div`
  width: 83%;
  color: white;
  margin-top: 50px;

  > ${Subtitle} {
    color: white;
    position: relative;
  }

  ${Title} {
    color: ${colors.tertiary} !important;
  }

  ${media.small`
  color: inherit;
  width: 40%;
  margin-top: 0px;
  margin-bottom: 150px;
  
  ${Title} {
    color: ${colors.primary} !important;
  }

    > ${Subtitle} {
      color: inherit;
      position: relative;
    }
  `}
`

const CallToActions = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  > div > a {
    margin-bottom: 12px;
  }

  button > div {
    height: 55px !important;
  }

  ${media.small`
    button > div {
      height: auto !important;
    }
  `}
`

export default props => {
  return (
    <Layout>
      <Block>
        <Filter />
        <SanityImage image={props.backgroundImage} height="100%" />
      </Block>
      <Headline>
        <Responsive to="tablet">
          <Title margin={{ bottom: "medium" }} size={"medium"}>
            {props.headline}
          </Title>
        </Responsive>
        <Responsive from="tablet">
          <Title margin={{ bottom: "medium" }}>{props.headline}</Title>
        </Responsive>
        <Subtitle style={{ position: "relative" }}>
          {/* <C type={"secondary"}>-</C> */}
          {props.subheadline}
        </Subtitle>
        <CallToActions>
          {props.ctas.map(button => (
            <React.Fragment>
              <Responsive to="tablet">
                <Button {...button} dark={true} size="small" spread={true} />
              </Responsive>
              <Responsive from="tablet">
                <Button {...button} dark={true} spread={true} />
              </Responsive>
            </React.Fragment>
          ))}
        </CallToActions>
      </Headline>
    </Layout>
  )
}
